import { animate, style, transition, trigger } from "@angular/animations";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { NavController } from "@ionic/angular";

import { LocalStorageService } from "../../_services/localStorage.service";
import { isStartTimeBeforeEndTime } from "src/app/helpers/utils";
@Component({
  selector: "app-clock",
  templateUrl: "./clock.component.html",
  styleUrls: ["./clock.component.scss"],
  standalone: false,
})
export class ClockComponent implements OnInit {
  @Output() annuler: EventEmitter<any> = new EventEmitter<any>();
  @Output() valid: EventEmitter<any> = new EventEmitter<any>();
  selectTime: string = "from";
  current_user: any;
  from: string = "12:00";
  to: string = "12:00";
  timeType = "AM";
  currentSelected: number = 12;
  rotation: number = 0;
  errorMessage= '';
  constructor(
    private navController: NavController,
    private localStorageService: LocalStorageService
  ) {}

  ngOnInit() {}

  getUserData() {
    const { client, token } = this.localStorageService.getUserData();
    this.current_user = client;
  }
  handleTimeType($event: any) {
    this.timeType = $event.target.value;
  }
  handleTime(time: number) {
    let debutHoursFormat =
      time.toString().length >= 2 ? time.toString() : `0${time}`;
    let date = `${debutHoursFormat}:00`;
    if (this.selectTime === "from") {
      this.from = date;
      this.switchTimeSelector("to");
    } else {
      this.to = date;
    }
  }

  handleSelectedTime(val: number) {
    this.errorMessage = ''
    this.handleTime(val);
    this.currentSelected = val;
    this.rotation = val * 30;
  }
  switchTimeSelector(val: string) {
    if (val === "to") {
      this.currentSelected = 12;
      this.rotation = 0;
    }
    this.selectTime = val;
  }

  goBack() {
    this.navController.pop();
  }
  cancel() {
    this.annuler.emit();
  }
  validate() {
    let payload = {
      from: this.from,
      to: this.to,
      timeType: this.timeType,
    };    
    if(this.getIsValidTime){
      this.valid.emit(payload);
      this.annuler.emit();
    }     
  }
  get getIsValidTime(){
    return this.from && this.to ?  isStartTimeBeforeEndTime(this.from+' '+this.timeType, this.to+' '+this.timeType) : true;
  }
}
